import React from "react";

import { Link } from "react-router-dom";

import { Button, makeStyles } from "@material-ui/core";
import clsx from "clsx";
const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: "white",
    color: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: "#dddddd",
    },
  },
  color: {},
}));
export default ({ color, children, ...rest }) => {
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      color="primary"
      className={clsx(!color && classes.button)}
      component={Link}
      to="/a"
      {...rest}
    >
      {children ? children : "Get Started"}
    </Button>
  );
};
